{
  "instances": {
    "startup": {
      "label": "Startup",
      "expand_all": "Expand all",

      "column": {
        "name": "Name",
        "duration": "Duration (ms)",
        "details": "Details"
      }
    }
  }
}
